import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useWorkspace = () => {
  return useQuery({
    queryKey: ['workspaces'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('workspaces')
        .select(`
          *,
          workspace_users!inner(workspace_role, is_system_member),
          owner:users!workspaces_owner_id_fkey(
            id,
            full_name,
            subscriptions(tier, status, data_source_limit, data_sources_used)
          )
        `)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    },
    retry: 2, // Retry twice if query fails (handles transient database issues)
    retryDelay: 500, // Wait 500ms between retries
  });
};

export const useCurrentWorkspace = (workspaceId: string | null) => {
  return useQuery({
    queryKey: ['workspace', workspaceId],
    queryFn: async () => {
      if (!workspaceId) return null;

      const { data, error } = await supabase
        .from('workspaces')
        .select(`
          *,
          workspace_users(user_id, workspace_role, is_system_member, users(full_name, email)),
          owner:users!workspaces_owner_id_fkey(
            id,
            full_name,
            subscriptions(tier, status, data_source_limit, data_sources_used)
          ),
          data_sources(
            id,
            name,
            type,
            is_active,
            last_synced_at,
            created_at,
            health_check_status,
            last_health_check_at,
            ga4_account_name,
            ga4_property_id
          )
        `)
        .eq('id', workspaceId)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!workspaceId,
  });
};
